<template>
  <div
    class="tw-flex tw-items-center tw-gap-4 tw-rounded-xs tw-px-6 tw-py-3 tw-shadow-round"
    :class="
      isError
        ? 'tw-bg-pink-200 tw-text-error'
        : 'tw-bg-gray-200 tw-text-gray-500'
    "
  >
    <i
      class="tw-text-base"
      :class="isError ? 'fas fa-exclamation-triangle' : 'fas fa-circle-info'"
    />
    <VText cfg="sans/16/medium" :color="isError ? 'error' : 'gray-500'">
      {{ mismatchText }}
    </VText>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VText from '~/components/ui/VText.vue'

export default defineComponent({
  components: {
    VText,
  },
  props: {
    isError: {
      type: Boolean,
      default: true,
    },
    mismatchText: {
      type: String,
      required: true,
    },
  },
})
</script>
